export default {
    share: null,
    course: null,
    times: null,
};



// WEBPACK FOOTER //
// ./src/store/share/state.js